var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCertificated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#certificated_svg__clip0_11804_67467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.027 21.257a3.418 3.418 0 00.857-3.273c-.616-2.344-.616-2.016 0-4.368a3.456 3.456 0 00-.857-3.273c-1.684-1.719-1.52-1.43-2.136-3.782a3.335 3.335 0 00-2.346-2.39c-2.3-.625-2.019-.469-3.702-2.18a3.263 3.263 0 00-3.203-.875c-2.308.633-1.98.625-4.28 0a3.276 3.276 0 00-3.203.875c-1.691 1.727-1.418 1.555-3.702 2.18a3.348 3.348 0 00-2.346 2.39c-.616 2.36-.452 2.063-2.136 3.782a3.418 3.418 0 00-.857 3.273c.616 2.352.616 2.024 0 4.368a3.456 3.456 0 00.857 3.273c1.684 1.719 1.52 1.43 2.136 3.782a3.335 3.335 0 002.346 2.39c1.621.446 1.31.336 1.793.57V41l7.256-3.633L29.76 41V28c.491-.227.172-.125 1.793-.57a3.348 3.348 0 002.346-2.391c.608-2.36.444-2.063 2.128-3.782zM22.488 22.82c-4.006 0-7.256-3.258-7.256-7.274s3.25-7.274 7.256-7.274 7.257 3.258 7.257 7.274-3.25 7.274-7.257 7.274z",
    stroke: "url(#certificated_svg__paint0_linear_11804_67467)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 15.5,
    r: 6.5,
    fill: "url(#certificated_svg__paint1_linear_11804_67467)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificated_svg__paint0_linear_11804_67467",
    x1: 24.206,
    y1: 76.122,
    x2: 49.611,
    y2: 68.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218FEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificated_svg__paint1_linear_11804_67467",
    x1: 23.265,
    y1: 33.415,
    x2: 33.785,
    y2: 28.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218FEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "certificated_svg__clip0_11804_67467"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
}

export default SvgCertificated;